/**
 * RedirectToBoard
 * Legacy `bo/` and `ep/` short links to the canonical `boards/` and `epics/`
 * routes, keeping the board, the open card, the view and the query string.
 *
 * BoardPage itself generated `bo/<board>/is/<card>` links until 2026-09-27,
 * while these routes were `<Navigate to="../boards">`, which drops every param
 * (the same trap RedirectToDocument in App.tsx fixes for `do/<id>`). So every
 * click on a card landed on the boards list instead of opening the card.
 */

import { Navigate, useLocation, useParams } from 'react-router-dom';

export function RedirectToBoard({ base }: { base: 'boards' | 'epics' }) {
  const { boardId, issueId, view } = useParams<{ boardId?: string; issueId?: string; view?: string }>();
  const location = useLocation();
  // useParams returns decoded values; re-encode them so an id holding `/`,
  // `?` or `#` stays one path segment.
  let to = `../${base}`;
  if (boardId) {
    to += `/${encodeURIComponent(boardId)}`;
    if (issueId) to += `/is/${encodeURIComponent(issueId)}`;
    else if (view) to += `/${encodeURIComponent(view)}`;
  }
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}
